import { today } from "../domain/dates.js";
import { ui } from "../app/store.js";

function periodRange() {
  const t = today(),
    p = ui.per || "year";
  if (p === "month") return [t.slice(0, 8) + "01", t];
  if (p === "last") {
    const d = new Date(t.slice(0, 8) + "01T00:00:00Z");
    d.setUTCDate(0);
    const e = d.toISOString().slice(0, 10);
    return [e.slice(0, 8) + "01", e];
  }
  return [t.slice(0, 4) + "-01-01", t];
}

export { periodRange };
